import { Link } from "react-router-dom";

export default function Logo({ size = "default" }) {
  const h = size === "small" ? "h-7" : size === "large" ? "h-12" : "h-9";
  return (
    <Link to="/" data-testid="nav-logo" className="flex-shrink-0">
      <img src="/logo.png" alt="LowKey Rents" className={`${h} w-auto object-contain`} />
    </Link>
  );
}
